import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import AddSkills from "../components/AddSkills";

export default class Skills extends Component {
  render() {
    const { onCancelClick, setToaster } = this.props;
    return (
      <div>
        <Switch>
          <Route
            exact
            path="/people/employees/dashboard/:EmployeeId/resume/8/setup"
            render={() => (
              <AddSkills
                {...this.props}
                onCancelClick={onCancelClick}
                editMode={false}
                setToaster={setToaster}
              />
            )}
          />
          <Route
            exact
            path="/people/employees/dashboard/:EmployeeId/resume/8/:SkillsId"
            render={() => (
              <AddSkills
                {...this.props}
                onCancelClick={onCancelClick}
                editMode={true}
                setToaster={setToaster}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}
